module.exports = __webpack_public_path__ + "img/pin_icon.52492b7c.svg";